import { render, staticRenderFns } from "./BbeeProcedimientosP.vue?vue&type=template&id=7f80f5c6"
import script from "./BbeeProcedimientosP.vue?vue&type=script&lang=js"
export * from "./BbeeProcedimientosP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports